import {
  UpdateField,
  FetchUsersRequest,
  DeleteUserRequest,
  SetDefaultData,
} from './users.actions'
import { getUsersState } from './users.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import ListTrait from 'src/app/traits/list.trait'
import { Subscription, of } from 'rxjs'
import { Map, fromJS } from 'immutable'
import { filtersToDbQuery } from '@shared/shared.utils'
import { TableFilterType } from '@shared/shared.types'

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent extends ListTrait implements OnInit, OnDestroy {
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public suspendedOptions = fromJS([
    { name: 'YES', title: 'Yes', translationKey: 'YES' },
    { name: 'NO', title: 'No', translationKey: 'NO' },
  ])
  public columns: object[] = [
    {
      prop: 'fullName',
      name: 'NAME',
      sortable: false,
      filterable: true,
      filterType: TableFilterType.String,
      hidden: true,
    },
    {
      prop: 'firstName',
      name: 'FIRST_NAME',
      sortable: true,
    },
    {
      prop: 'lastName',
      name: 'LAST_NAME',
      sortable: true,
    },
    {
      prop: 'email',
      name: 'EMAIL',
      sortable: true,
      filterable: true,
      filterType: TableFilterType.String,
    },
    {
      prop: 'suspended',
      name: 'SUSPENDED',
      template: 'suspendedColumn',
      filterable: true,
      filterType: TableFilterType.Boolean,
      select$: of(
        fromJS([
          { name: 'YES', title: 'Yes', translationKey: 'YES' },
          { name: 'NO', title: 'No', translationKey: 'NO' },
        ]),
      ),
    },
    {
      prop: 'twoFactorAuth',
      name: 'TWO_FACTOR_AUTH_ENABLED',
      template: 'twoFactorColumn',
    },
    {
      prop: 'roles',
      name: 'ROLE',
      template: 'rolesColumn',
      // render(column: any) {
      //   return column.map((r: any) => r.get('title')).join(', ')
      // },
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  public filters: any[]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store.pipe(select(getUsersState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')
      this.filters = state.get('filters').toJS()

      if (
        state.get('shouldReload') !== this.shouldReload &&
        state.get('shouldReload')
      ) {
        this.handleFilterChange()
      }
      this.shouldReload = state.get('shouldReload')
    })

    this.route$ = this.route.queryParams.subscribe((params) => {
      this.handleFilterChange(params)
    })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  getJoinedRoles(roles: any[]) {
    return roles.map((r: any) => r.get('title')).join(', ')
  }

  handleFilterChange(data?: any) {
    const filters = data?.filters ?? this.filters
    const pagination = data?.pagination ?? this.state.get('pagination').toJS()
    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch(new UpdateField('filters', filters, 'list'))
    this.store.dispatch(new UpdateField('pagination', pagination, 'list'))

    const dbFilters: any = filtersToDbQuery(filters)

    // Convert 'YES'/'NO' to boolean for suspended filter
    if (dbFilters.matchOr) {
      dbFilters.matchOr = dbFilters.matchOr.map((filter: any) => {
        if (filter.field === 'suspended' && typeof filter.value === 'string') {
          return { ...filter, value: filter.value === 'YES' }
        }
        return filter
      })
    }

    if (dbFilters.matchAnd) {
      dbFilters.matchAnd = dbFilters.matchAnd.map((filter: any) => {
        if (filter.field === 'suspended' && typeof filter.value === 'string') {
          return { ...filter, value: filter.value === 'YES' }
        }
        return filter
      })
    }

    this.store.dispatch<any>(
      new FetchUsersRequest({
        filters: dbFilters,
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )
  }

  deleteUser(id: number) {
    this.store.dispatch(new DeleteUserRequest(id))
  }
}
